/**
 * @fileoverview React context that handles the menu open and closed state.
 *
 * @format
 */

import { createContext, useContext, useState } from 'react';

interface URLSegmentInfo {
  originalSegment: string;
  segment: string;
  language: string;
}

interface URLContextType {
  translatedUrlSegments: URLSegmentInfo[];
  setTranslatedUrlSegments: (translatedUrlSegments: URLSegmentInfo[]) => void;
}

export const URLContext = createContext<URLContextType>({
  translatedUrlSegments: [],
  setTranslatedUrlSegments: () => {},
});

interface URLProviderProps {
  children: React.ReactNode;
}

export const URLProvider = ({ children }: URLProviderProps) => {
  const [translatedUrlSegments, setTranslatedUrlSegments] = useState<
    URLSegmentInfo[]
  >([]);

  return (
    <URLContext.Provider
      value={{ translatedUrlSegments, setTranslatedUrlSegments }}
    >
      {children}
    </URLContext.Provider>
  );
};

export const useURL = () => useContext(URLContext);
